// extracted by mini-css-extract-plugin
export default {"defaultBullet":"Bullet_defaultBullet__Yln6e","emphasizedBullet":"Bullet_emphasizedBullet__D4z71"};